import axios from "axios";

export default function ScheduleFormService(formData, method, groupId) {
  return axios({
    method: method,
    url: process.env.REACT_APP_API_HOST + "/schedule/" + groupId,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
